"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrebidAdUnits = void 0;
var helpers_1 = require("../../../helpers");
var configureBidders_1 = require("../utils/configureBidders");
var getPlacementFromAdUnitId_1 = __importDefault(require("../utils/getPlacementFromAdUnitId"));
var getPlacementSizes_1 = require("../utils/getPlacementSizes");
/**
 *
 * Takes a list of adUnitIds and provides a list of adUnit objects in a structure that prebid.addAdUnits
 * expects, after applying some filtering based on feature flags and user context.
 *
 * @param {Array<String>} adUnitIds a list of all the placement IDs to map to Prebid Ad Units
 * @param {Array<Object>} testGroups feature gates that may be used to filter bidders
 * @param {String} userGeo users location used to filter bidders
 * @param {String} userDeviceType used to filter bidders
 * @returns {Array} a list of Prebid AdUnits
 */
function getPrebidAdUnits(adUnitIds, testGroups, userGeo, userDeviceType) {
    var adUnits = [];
    adUnitIds.forEach(function (adUnitId) {
        var placement = (0, getPlacementFromAdUnitId_1.default)(adUnitId);
        var sizes = (0, getPlacementSizes_1.getPlacementSizes)(placement);
        var configuredBidders = (0, configureBidders_1.configureBidders)(placement, testGroups, userGeo, userDeviceType);
        if (sizes) {
            var adUnit = {
                code: adUnitId,
                mediaTypes: {
                    banner: {
                        sizes: sizes,
                    },
                },
                bids: configuredBidders,
                ortb2Imp: {
                    ext: {
                        gpid: "".concat(placement, "#").concat(adUnitId),
                    },
                },
            };
            adUnits.push(adUnit);
        }
        else if ((0, helpers_1.getCookie)("debug-ads")) {
            console.log("cannot find sizes for ad placement ".concat(adUnitId, ". omitting it"));
        }
    });
    return adUnits;
}
exports.getPrebidAdUnits = getPrebidAdUnits;
